

import React from 'react';
import { withRouter } from 'react-router-dom';


import AdvancedFiltersComponent from '../components/AdvancedFilters';

















const DEFAULT_BASE = '/pro';

function AdvancedFilters({ location, basePath, ...props }) {
  return (
    <AdvancedFiltersComponent
      location={location}
      basePath={basePath || DEFAULT_BASE}
      urlParams={location.search.substr(1)}
      {...props} />);


}

export const AdvancedFiltersWithRouter = withRouter(AdvancedFilters);

export default AdvancedFilters;